import { cn } from "../../lib";

export type ScopedPanelSide = "top" | "bottom" | "left" | "right";

/** Matches learn structure sidebar chapter cards (`LEARN_SIDEBAR_SUBTLE_BORDER_COLOR_CLASS`). */
export const scopedPanelSheetBorderColorClassName =
	"border-black/15 dark:border-white/20";

/** Full box border when `org-app-shell` is at main content width (pairs with `@max-[39.999rem]/org-app-shell`). */
const scopedPanelSheetWideBorderClassName = "@min-[40rem]/org-app-shell:border";

const SCOPED_PANEL_EDGE_CHROME: Record<ScopedPanelSide, string> = {
	top: cn(
		scopedPanelSheetBorderColorClassName,
		"border-0 border-b",
		scopedPanelSheetWideBorderClassName,
		"shadow-[0_8px_24px_-4px_rgba(0,0,0,0.18)]",
	),
	bottom: cn(
		scopedPanelSheetBorderColorClassName,
		"border-0 border-t",
		scopedPanelSheetWideBorderClassName,
		"shadow-[0_-8px_24px_-4px_rgba(0,0,0,0.18)]",
	),
	left: cn(
		scopedPanelSheetBorderColorClassName,
		"border-0 border-r",
		scopedPanelSheetWideBorderClassName,
		"shadow-[8px_0_24px_-4px_rgba(0,0,0,0.18)]",
	),
	right: cn(
		scopedPanelSheetBorderColorClassName,
		"border-0 border-l",
		scopedPanelSheetWideBorderClassName,
		"shadow-[-8px_0_24px_-4px_rgba(0,0,0,0.18)]",
	),
};

export function scopedPanelEdgeChromeClassName(
	side: ScopedPanelSide,
	className?: string,
) {
	return cn(SCOPED_PANEL_EDGE_CHROME[side], className);
}

export function scopedPanelSlideInClassName(side: ScopedPanelSide) {
	switch (side) {
		case "top":
			return "animate-in slide-in-from-top duration-300";
		case "bottom":
			return "animate-in slide-in-from-bottom duration-300";
		case "left":
			return "animate-in slide-in-from-left duration-300";
		case "right":
			return "animate-in slide-in-from-right duration-300";
	}
}
